// extracted by mini-css-extract-plugin
export default {"pageBtn":"CustomerPagination_pageBtn__ZwtUO","activePageBtn":"CustomerPagination_activePageBtn__gdoh9"};